import { render, staticRenderFns } from "./temas-interes.vue?vue&type=template&id=e406d826&"
import script from "./temas-interes.vue?vue&type=script&lang=js&"
export * from "./temas-interes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports